var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class HttpError extends Error {
  constructor(status, statusText, response) {
    super(statusText);
    __publicField(this, "response");
    __publicField(this, "status");
    __publicField(this, "statusText");
    this.status = status;
    this.statusText = statusText;
    this.response = response;
  }
}
export {
  HttpError
};
